import React from 'react';

export default function CheckExportDetails(props) {
  return (
    <div
      className="shadow-lg rounded-2xl w-64 bg-slate-800 p-4 absolute top-64px m-auto flex overflow-auto z-50 ml-0 2xl:ml-7">
      <ul className="text-sm text-white w-full mt-6 mb-6">

        {
          props.checks.map(success_check => (<li className="mb-3 flex items-center ">
            <svg className="h-6 min-w-[10%] mr-2" xmlns="http://www.w3.org/2000/svg" width="6" height="6"
                 stroke="currentColor"
                 fill="#10b981" viewBox="0 0 1792 1792">
              <path
                d="M1412 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zm252 162q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z">
              </path>
            </svg>
            {success_check.name}
          </li>))
        }

        {
          props.errors.map(error => (<li className="mb-3 flex items-center">
            <svg className="h-6 min-w-[10%] mr-2" xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="red"
                 viewBox="0 0 1792 1792">
              <path
                d="M1277 1122q0-26-19-45l-181-181 181-181q19-19 19-45 0-27-19-46l-90-90q-19-19-46-19-26 0-45 19l-181 181-181-181q-19-19-45-19-27 0-46 19l-90 90q-19 19-19 46 0 26 19 45l181 181-181 181q-19 19-19 45 0 27 19 46l90 90q19 19 46 19 26 0 45-19l181-181 181 181q19 19 45 19 27 0 46-19l90-90q19-19 19-46zm387-226q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z">
              </path>
            </svg>
            {error.name}
          </li>))
        }

      </ul>
    </div>
  );
}
